exports.encrypt = function (self, block) {
  return self._cipher.encryptBlock(block)
}

exports.decrypt = function (self, block) {
  return self._cipher.decryptBlock(block)
}



//////////////////
// WEBPACK FOOTER
// ./~/_browserify-aes@1.2.0@browserify-aes/modes/ecb.js
// module id = 209
// module chunks = 8